import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import authentication from './authentication';
import entities from './entities';
import general from './general';
import postApprovalPlaid from './post_approval_plaid';
import sessions from './sessions';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    entities,
    general,
    sessions,
    authentication,
    post_approval_plaid: postApprovalPlaid,
  });

export default createRootReducer;
